<template>
  <div class='opc-succezz__promotes' v-if='showPromotes && filterKeys.length'>
    <h2 class='opc-succezz__promotes-title'>{{ $t('billing.success.confirmation.continue_shopping') }}</h2>
    <promotes-addon class='opc-succezz__promotes-addon' :filter-keys='filterKeys' @add='handleAddToCart' />
  </div>
</template>

<script>
import PromotesAddon from '@/views/succezz/promotes/promotes-addon.vue';
import { getAdd2CartUrl, PROMOTES_ADDON_PLAN_TYPES } from '@/views/succezz/utils';
import { mapGetters } from 'vuex';
import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';
import { filterAddonForKeys, simpleFilterAddonForKeys, planTypesForMeeting } from '@/views/config/addon-cards/index.vue';
import { AllPlans } from '@/plans';

export default {
  components: {
    PromotesAddon,
  },
  props: {
    showPromotes: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['boughtPlans', 'persistState', 'freeTrialPlans', 'allPlanMap']),
    getSelectedPlans() {
      return this.persistState.confirmationDetails.getSelectedPlans;
    },
    allAddonPlans() {
      return this.filterPlanTypes.reduce((prev, k) => {
        const plan = AllPlans.find(p => p?.key === k && p.components?.addon);
        prev.push(plan);
        return prev;
      }, []);
    },
    applicableAddonList() {

      const hasAICPlan = this.boughtPlans.find(p => p.type === planTypes.ZM_AI_COMPANION);
      if (hasAICPlan) {
        return simpleFilterAddonForKeys(this.allAddonPlans)
      }
      return filterAddonForKeys(
        this.allAddonPlans,
        planTypesForMeeting(),
        this.getSelectedPlans,
        this.boughtPlans,
        this.freeTrialPlans,
        this.allPlanMap
      );
    },
    filterPlanTypes() {
      const hasBizPlan = this.boughtPlans.find(p => p.category === BASE_PLAN_SUB_TYPES.BIZ);
      const hasAICPlan = this.boughtPlans.find(p => p.type === planTypes.ZM_AI_COMPANION);
      return PROMOTES_ADDON_PLAN_TYPES.filter(type => {
        if (hasBizPlan && type === planTypes.ZOOM_SCHEDULER) return false;
        if (hasAICPlan && type !== planTypes.ZOOM_MEETING) return false;
        if (this.boughtPlans.find(p => p.type === type)) return false;
        return true;
      }).map(k => planTypes[k]);
    },
    filterKeys() {
      // only show the first three add-ons
      return this.applicableAddonList.map((x) => x.key)?.slice(0,3) ?? [];
    },
  },
  methods: {
    handleAddToCart(type) {
      this.$tracking.buyInteraction('purchase confirmation', `add-ons - ${getTrackingProductNameByPlanType(type)} - add`);
      const url = getAdd2CartUrl(type);
      window.location.href = url;
    }
  }
};
</script>

<style lang='scss'>
.opc-succezz__promotes {
  margin-top: 48px;

  &-title {
    border-top: 1px solid #DFE3E8;
    padding-top: 48px;
    font-size: 24px;
    font-weight: 500;
  }

  &-addon {
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 24px;
    flex-direction: column;

    .opc-addon {
      min-height: 120px;
    }

    .opc-tile + .opc-tile {
      margin-top: 0;
    }
  }
}
</style>
